// React
import React, {Component} from "react";
import {connect} from "react-redux";
// Routing
import {withRouter} from "react-router-dom";
// Translations
import {withTranslation} from "react-i18next";
// Components
import { Dialog, CircularProgress } from "@material-ui/core";
import {Button} from "@components/Input";
// Assets
import {chargebeeInfoSvg, chargebeeArrowSvg, closeSvg} from "assets";
// Styles
import "../styles/styles.scss";
// Chargebee
import {ChargebeeAPI} from "views/Chargebee/infrastructure";

class ChargebeeCheckout extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            trial: this.props.trial ?? true,
            checkout: false,
            redirection: false,

            frequency: "Yearly",
            currency: "EUR",

            plan_id: this.props.plan,

            cbInstance: window.Chargebee.init({
                site: this.props.data.user.chargebee_customer_site
            })
        };
    }

    handleChargebeeChange = (property, value) => {
        this.setState({
            ...this.state, [property]: value
        });
    };

    handleChargebee = () => {
        const {access, user} = this.props.data;

        this.state.cbInstance.openCheckout({
            hostedPage: () => {
                let data = JSON.stringify({
                    chargebee_product_id: `${this.state.plan_id}-${this.state.currency}-${this.state.frequency}`,
                    chargebee_customer_id: user.chargebee_customer_id,
                    trial: this.state.trial
                });
                let chargebee_api = new ChargebeeAPI(access.userId, access, this.props, data);
                return chargebee_api.get_chargebee_hosted_page();
            },
            success: () => {
                this.handleDialogAction("redirection", true);
                setTimeout(() => {
                    window.location.href = process.env.REACT_APP_URL_CENTRIBOT;
                }, 15000);
                this.state.cbInstance.closeAll();
            },
        });
        this.handleDialogAction("checkout", false);
    };

    handleDialogAction = (dialog, action) => {
        this.setState({[dialog]: action});
    };

    render() {
        const {t, text} = this.props;
        const {checkout, redirection, trial} = this.state;
        return (
            <React.Fragment>
                <Button type={"pro"} onClick={() => this.handleDialogAction("checkout", true)} text={text} />
                <Dialog className={"chargebee_modal"} open={checkout}>
                    <div className={"chargebee_modal_close"} onClick={() => this.handleDialogAction("checkout", false)}>{closeSvg()}</div>
                    <div className={"chargebee_modal_header"}>
                        <img alt="centribal-chargebee" src={process.env.PUBLIC_URL + "/centribal_chargebee.png"}/>
                        <span>{t("checkout.title")}</span>
                    </div>
                    <div className={"chargebee_modal_content"}>
                        <div className={"content_element"}>
                            <div className={"content_element_title"}>
                                <span>{t("checkout.periodicity")}</span>
                                <span></span>
                            </div>
                            <div className={"content_element_option"}>
                                <span className={this.state.frequency === "Yearly" ? "selected" : ""} onClick={() => this.handleChargebeeChange("frequency", "Yearly")}>{t("checkout.frequency.yearly")}</span>
                                <span className={this.state.frequency === "Monthly" ? "selected" : ""}  onClick={() => this.handleChargebeeChange("frequency", "Monthly")}>{t("checkout.frequency.monthly")}</span>
                            </div>
                        </div>
                        <div className={"content_element"}>
                            <div className={"content_element_title"}>
                                <span>{t("checkout.currency")}</span>
                                <span></span>
                            </div>
                            <div className={"content_element_option"}>
                                <span className={this.state.currency === "EUR" ? "selected" : ""} onClick={() => this.handleChargebeeChange("currency", "EUR")}>EUR</span>
                                <span className={this.state.currency === "USD" ? "selected" : ""} onClick={() => this.handleChargebeeChange("currency", "USD")}>USD</span>
                            </div>
                        </div>
                    </div>
                    <div className={"chargebee_modal_actions"}>
                        { trial &&
                            <div>
                                {chargebeeInfoSvg()}
                                <span>{t("checkout.info")}</span>
                            </div>
                        }
                        <button onClick={() => this.handleChargebee()}>
                            <span>{t("checkout.action")} {chargebeeArrowSvg()}</span>
                        </button>
                    </div>
                </Dialog>
                <Dialog className={"chargebee_modal"} open={redirection}>
                    <div className={"chargebee_modal_header"}>
                        <img alt="centribal-chargebee" src={process.env.PUBLIC_URL + "/centribal_chargebee.png"}/>
                        <span>{t("checkout.loading.action")}</span>
                    </div>
                    <div className={"chargebee_modal_content"}>
                        <div className={"content_loading"}>
                            <CircularProgress size={70} thickness={2}/>
                            <span>{t("checkout.loading.info")}</span>
                        </div>
                    </div>
                </Dialog>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state
    };
};

const connect_ = connect(
    mapStateToProps
)(ChargebeeCheckout);

export default withTranslation("plans")(withRouter(connect_));